import cx from 'classnames';

export function createVariants({ base = '', variants = {}, sizes = {}, defaultVariant, defaultSize }) {
  return function getClasses({ variant, size, className, disabled }) {
    const chosenVariant = variant || defaultVariant;
    const chosenSize = size || defaultSize;
    return cx(
      base,
      chosenVariant && variants[chosenVariant],
      chosenSize && sizes[chosenSize],
      disabled && 'opacity-50 pointer-events-none',
      className,
    );
  };
}


